/* Normalize Shopify Forms width inside Shadow DOM */
(function () {
  const HOST_SELECTOR = '#raffle-form shopify-forms-embed';
  const CSS = `
    /* Adapt width */
    #app-embed,
    [data-testid="app-router"],
    #form-container-ref,
    [data-sizing="form-wrapper"],
    form {
      box-sizing: border-box !important;
      max-width: 100% !important;
      width: 100% !important;
      margin: 0 auto !important;
    }
    
    /* Remove border radius */
    input, button {
        border-radius: 0 !important;
    }

    p {
    color: #20202080;
    }
  `;

  function inject(sr) {
    if (!sr) return false;
    let style = sr.getElementById('raffle-form-shadow-style');
    if (!style) {
      style = document.createElement('style');
      style.id = 'raffle-form-shadow-style';
      style.textContent = CSS;
      sr.appendChild(style);
    }
    // Also patch inline styles on primary container to beat inline widths from app
    const target = sr.querySelector('#app-embed, #form-container-ref, [data-sizing="form-wrapper"], form');
    if (target) {
      target.style.boxSizing = 'border-box';
      target.style.maxWidth = '100%';
      target.style.width = '100%';
      target.style.margin = '0 auto';
    }
    return true;
  }

  function watchShadow(embed) {
    const sr = embed.shadowRoot;
    if (!sr) return;
    if (!sr.__raffleMO) {
      sr.__raffleMO = new MutationObserver(() => inject(sr));
      sr.__raffleMO.observe(sr, { childList: true, subtree: true });
    }
  }

  function ensureForHost(embed) {
    if (!embed || embed.__raffleInit) return;
    embed.__raffleInit = true;
    // Host should fill wrapper
    embed.style.display = 'block';
    embed.style.width = '100%';

    const tryAttach = () => {
      if (!embed.isConnected) return true; // stop if removed
      if (embed.shadowRoot) {
        inject(embed.shadowRoot);
        watchShadow(embed);
        return true;
      }
      return false;
    };

    if (!tryAttach()) {
      // Poll briefly until the shadowRoot is attached (host mutations do not fire for SR attach)
      let attempts = 0;
      const t = setInterval(() => {
        if (tryAttach() || attempts++ > 120) clearInterval(t); // ~6s at 50ms
      }, 50);
    }
  }

  function scan() {
    document.querySelectorAll(HOST_SELECTOR).forEach(ensureForHost);
  }

  // Initial scan
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Rescan when DOM changes (app blocks mount later)
  const docMO = new MutationObserver(scan);
  docMO.observe(document.documentElement, { childList: true, subtree: true });
})();
